import './Cover.css';

const Cover = ({ src, text }) => {
  return (
    <section className='cover__section'>
        <img src={src} alt={text} className="cover__section-image" />
        <h2 className="cover__section-text mont-m">{text}</h2>
    </section>
  )
}

export default Cover